.head {
  margin: 4px 0 16px;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

/* Ссылка набрана моноширинным: в ней важен каждый символ, и разная
   ширина цифр и букв мешает заметить опечатку при сверке. */
.link {
  display: block;
  padding: 12px 14px;
  font-family: var(--mono);
  font-size: 13px;
  line-height: 1.4;
  color: var(--ink-soft);
  word-break: break-all;
  background: var(--surface-sunken);
  border-radius: var(--r-md);
}

.linkOnHero {
  color: var(--hero-fg);
  background: rgb(255 255 255 / 10%);
}

.copyRow {
  display: flex;
  gap: 10px;
  margin-top: 12px;
}

.note {
  margin: 10px 4px 0;
  font-size: 13px;
  line-height: 1.4;
  color: var(--muted);
}

.empty {
  padding: 22px var(--pad);
  font-size: 14px;
  color: var(--muted);
  text-align: center;
}

.money {
  color: var(--ok);
}
